/* Feeliva — scripts propios (sin librerías) */
(function () {
  "use strict";
  // Cada sección enlaza este archivo: que solo se ejecute una vez por página
  if (window.FV) return;

  var SECCION_CARRITO = "fv-carrito";
  var PANELES = { "fv-contacto": "contacto", "fv-rastrear": "rastrear", "fv-historia": "historia" };
  var reducido = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  var abierto = null;
  var ultimoFoco = null;
  var yaAbiertoAlCargar = false;

  window.FV = { abrir: abrir, cerrar: cerrar, agregar: agregar, pintarCarrito: pintarCarrito };

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  /* ---------- Apariciones al hacer scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll(".fv-reveal:not(.fv-visible)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("fv-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("fv-visible"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () {
      document.querySelectorAll(".fv-reveal:not(.fv-visible)").forEach(function (e) {
        if (e.getBoundingClientRect().top < window.innerHeight) e.classList.add("fv-visible");
      });
    }, 2500);
  }

  /* ---------- Galería del producto ---------- */
  function initGaleria(root) {
    if (root.fvListo) return;
    root.fvListo = true;
    var slides = [].slice.call(root.querySelectorAll(".fv-pdp__slide"));
    var thumbs = [].slice.call(root.querySelectorAll(".fv-pdp__thumb"));
    if (!slides.length) return;
    var actual = Math.max(0, slides.findIndex(function (s) { return s.classList.contains("is-active"); }));
    // Carga por turnos: primero la foto activa (viene en el HTML), luego miniaturas y después el resto de fotos
    function cargar(img, alTerminar) {
      if (!img || !img.hasAttribute("data-fv-src")) { if (alTerminar) alTerminar(); return; }
      if (alTerminar) { img.addEventListener("load", alTerminar, { once: true }); img.addEventListener("error", alTerminar, { once: true }); }
      if (img.hasAttribute("data-fv-srcset")) { img.setAttribute("srcset", img.getAttribute("data-fv-srcset")); img.removeAttribute("data-fv-srcset"); }
      img.setAttribute("src", img.getAttribute("data-fv-src"));
      img.removeAttribute("data-fv-src");
    }
    function cargarFoto(k) { var s = slides[(k + slides.length) % slides.length]; cargar(s && s.querySelector("img")); }
    function cargarResto(k) {
      while (k < slides.length && !(slides[k].querySelector("img[data-fv-src]"))) k++;
      if (k < slides.length) cargar(slides[k].querySelector("img"), function () { cargarResto(k + 1); });
    }
    var ahorro = navigator.connection && navigator.connection.saveData;
    function despuesDeLaPrincipal() {
      thumbs.forEach(function (t) { cargar(t.querySelector("img")); });
      function resto() { if (!ahorro) setTimeout(function () { cargarResto(0); }, 300); }
      if (document.readyState === "complete") resto(); else window.addEventListener("load", resto, { once: true });
    }
    var imgActiva = slides[actual].querySelector("img");
    if (!imgActiva || imgActiva.hasAttribute("data-fv-src") || imgActiva.complete) despuesDeLaPrincipal();
    else { imgActiva.addEventListener("load", despuesDeLaPrincipal, { once: true }); imgActiva.addEventListener("error", despuesDeLaPrincipal, { once: true }); }
    function ir(i, sinScroll) {
      actual = (i + slides.length) % slides.length;
      if (!sinScroll) { cargarFoto(actual); cargarFoto(actual + 1); cargarFoto(actual - 1); }
      slides.forEach(function (s, k) {
        var on = k === actual;
        s.classList.toggle("is-active", on);
        s.setAttribute("aria-hidden", on ? "false" : "true");
      });
      thumbs.forEach(function (t, k) {
        var on = k === actual;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-current", on ? "true" : "false");
        var p = t.parentElement;
        if (on && !sinScroll && p && p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - 12, behavior: "smooth" });
      });
    }
    ir(actual, true);
    thumbs.forEach(function (t, k) { t.addEventListener("click", function () { ir(k); }); });
    var prev = root.querySelector(".fv-pdp__flecha--prev");
    var next = root.querySelector(".fv-pdp__flecha--next");
    if (prev) prev.addEventListener("click", function () { ir(actual - 1); });
    if (next) next.addEventListener("click", function () { ir(actual + 1); });
    var principal = root.querySelector(".fv-pdp__principal");
    var x0 = null, y0 = null;
    if (principal) {
      principal.addEventListener("pointerdown", function (e) { x0 = e.clientX; y0 = e.clientY; });
      principal.addEventListener("pointerup", function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      principal.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") ir(actual - 1);
        if (e.key === "ArrowRight") ir(actual + 1);
      });
    }
    root.fvIrAMedia = function (mediaId) {
      var k = slides.findIndex(function (s) { return s.getAttribute("data-media-id") === String(mediaId); });
      if (k > -1) ir(k);
    };
  }

  /* ---------- Zona de compra ---------- */
  function initProducto(sec) {
    if (sec.fvListo) return;
    sec.fvListo = true;
    var form = sec.querySelector("form.fv-pdp__form");
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    var boton = form.querySelector("[data-fv-boton]");
    var galeria = sec.querySelector(".fv-pdp__galeria");
    var datos = sec.querySelector("script[data-fv-variantes]");
    var destino = sec.getAttribute("data-destino") || "/cart";
    var modo = sec.getAttribute("data-destino-modo") || "drawer";
    var variantes = [];
    try { variantes = datos ? JSON.parse(datos.textContent) : []; } catch (e) { variantes = []; }
    var txtComprar = boton ? boton.getAttribute("data-texto") : "";
    var txtAgotado = boton ? boton.getAttribute("data-agotado") : "";
    var disponible = boton ? !boton.disabled : true;

    function avisoCompra(texto) {
      var p = form.querySelector(".fv-pdp__error");
      if (!texto) { if (p) p.parentNode.removeChild(p); return; }
      if (!p) {
        p = document.createElement("p");
        p.className = "fv-pdp__error";
        p.setAttribute("role", "alert");
        if (boton) boton.insertAdjacentElement("afterend", p);
        else form.appendChild(p);
      }
      p.textContent = texto;
      // Si se pulsó la barra de abajo, el aviso queda fuera de la pantalla: se lleva a la vista
      var r = p.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) p.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "center" });
    }

    function pintar(v) {
      if (!v) return;
      disponible = !!v.disponible;
      if (input) input.value = v.id;
      sec.querySelectorAll("[data-fv-precio]").forEach(function (e) { e.innerHTML = v.precio; });
      sec.querySelectorAll("[data-fv-antes]").forEach(function (e) { e.innerHTML = v.antes || ""; e.hidden = !v.antes; });
      sec.querySelectorAll("[data-fv-ahorro]").forEach(function (e) { e.textContent = v.ahorro || ""; e.hidden = !v.ahorro; });
      sec.querySelectorAll("[data-fv-color-nombre]").forEach(function (e) { e.textContent = v.opcion; });
      if (boton) {
        boton.disabled = !disponible;
        var t = boton.querySelector("[data-fv-boton-texto]") || boton;
        t.textContent = disponible ? txtComprar : txtAgotado;
      }
      sec.querySelectorAll("[data-fv-sticky-boton]").forEach(function (b) { b.disabled = !disponible; });
      if (v.media && galeria && galeria.fvIrAMedia) galeria.fvIrAMedia(v.media);
      avisoCompra("");
      if (sec.hasAttribute("data-url-variante")) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", v.id);
          window.history.replaceState({}, "", u.toString());
        } catch (e) {}
      }
    }

    sec.querySelectorAll(".fv-color").forEach(function (b) {
      b.addEventListener("click", function () {
        var val = b.getAttribute("data-valor");
        sec.querySelectorAll(".fv-color").forEach(function (x) {
          var on = x === b;
          x.classList.toggle("is-active", on);
          x.setAttribute("aria-pressed", on ? "true" : "false");
        });
        pintar(variantes.find(function (v) { return v.opcion === val; }));
      });
    });

    var select = sec.querySelector("[data-fv-select]");
    if (select) select.addEventListener("change", function () {
      pintar(variantes.find(function (v) { return String(v.id) === select.value; }));
    });

    form.addEventListener("submit", function (e) {
      if (!window.fetch || !input) return;
      e.preventDefault();
      avisoCompra("");
      if (boton) { boton.classList.add("is-cargando"); boton.disabled = true; }
      agregar(input.value, 1)
        .then(function (j) {
          if (modo === "drawer" && pintarCarrito(j.sections && j.sections[SECCION_CARRITO])) abrir("carrito", null, boton);
          else window.location.href = destino;
        })
        .catch(function (err) {
          if (err && err.datos) avisoCompra((err.datos.status === 422 && err.datos.description) || sec.getAttribute("data-texto-error"));
          else form.submit();
        })
        .then(function () {
          if (boton) { boton.classList.remove("is-cargando"); boton.disabled = !disponible; }
        });
    });

    var sticky = sec.querySelector(".fv-sticky");
    if (sticky && boton && "IntersectionObserver" in window) {
      // Margen inferior enorme: solo cuenta el borde superior de la pantalla, así la barra aparece
      // aunque la página salte de golpe por encima del botón (volver atrás desde el pago, recargar).
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { sticky.classList.toggle("is-visible", !x.isIntersecting && x.boundingClientRect.top < 0); });
      }, { threshold: 0, rootMargin: "0px 0px 100000px 0px" });
      io.observe(boton);
      var sb = sticky.querySelector("[data-fv-sticky-boton]");
      if (sb) sb.addEventListener("click", function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  function initAcordeones() {
    document.querySelectorAll("[data-fv-acordeon-unico]").forEach(function (g) {
      if (g.fvListo) return;
      g.fvListo = true;
      g.addEventListener("toggle", function (e) {
        if (e.target.tagName === "DETAILS" && e.target.open) {
          g.querySelectorAll("details[open]").forEach(function (d) { if (d !== e.target) d.open = false; });
        }
      }, true);
    });
  }

  /* ---------- Paneles laterales: menú (con vistas) y carrito ---------- */
  function portal() {
    // El menú vive dentro de la barra fija; lo sacamos al final de la página para que quede por encima de todo
    document.querySelectorAll("[data-fv-portal]").forEach(function (el) {
      if (el.parentNode === document.body) return;
      [].slice.call(document.body.children).forEach(function (c) {
        if (c !== el && el.id && c.id === el.id) {
          if (abierto === c) { abierto = null; document.documentElement.classList.remove("fv-bloqueo"); }
          document.body.removeChild(c);
        }
      });
      document.body.appendChild(el);
    });
  }

  function marcarBotones(nombre, on) {
    document.querySelectorAll('[data-fv-abrir="' + nombre + '"]').forEach(function (b) {
      b.setAttribute("aria-expanded", on ? "true" : "false");
    });
  }

  function mostrarVista(d, vista) {
    var elegida = d.querySelector('[data-fv-vista="' + vista + '"]') || d.querySelector('[data-fv-vista="menu"]');
    if (!elegida) return;
    d.querySelectorAll("[data-fv-vista]").forEach(function (v) { v.hidden = v !== elegida; });
    var cuerpo = elegida.querySelector(".fv-drawer__cuerpo");
    if (cuerpo) cuerpo.scrollTop = 0;
  }

  function enfocarVista() {
    if (!abierto) return;
    var v = abierto.querySelector("[data-fv-vista]:not([hidden])") || abierto;
    var b = v.querySelector(".fv-drawer__volver, .fv-drawer__cerrar") || abierto.querySelector(".fv-drawer__panel");
    if (b && b.focus) b.focus({ preventScroll: true });
  }

  function abrir(nombre, vista, disparador) {
    var d = document.querySelector('[data-fv-drawer="' + nombre + '"]');
    if (!d) return false;
    if (abierto && abierto !== d) cerrar(true);
    if (d.querySelector("[data-fv-vista]")) mostrarVista(d, vista || "menu");
    if (abierto === d) { enfocarVista(); return true; }
    ultimoFoco = disparador || document.activeElement;
    clearTimeout(d.fvTiempo);
    d.hidden = false;
    void d.offsetWidth;
    d.classList.add("is-abierto");
    document.documentElement.classList.add("fv-bloqueo");
    marcarBotones(nombre, true);
    abierto = d;
    setTimeout(enfocarVista, reducido ? 0 : 80);
    return true;
  }

  function cerrar(sinDevolverFoco) {
    var d = abierto;
    if (!d) return;
    abierto = null;
    d.classList.remove("is-abierto");
    document.documentElement.classList.remove("fv-bloqueo");
    marcarBotones(d.getAttribute("data-fv-drawer"), false);
    d.fvTiempo = setTimeout(function () { d.hidden = true; }, reducido ? 0 : 420);
    if (!sinDevolverFoco && ultimoFoco && document.contains(ultimoFoco) && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
    ultimoFoco = null;
  }

  function irAComprar() {
    var el = document.getElementById("fv-comprar");
    if (el) el.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
  }

  /* ---------- Carrito ---------- */
  function peticionCarrito(ruta, cuerpo, intento) {
    intento = intento || 0;
    return fetch(raiz() + ruta, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      // Shopify saturado (429) o fallo puntual del servidor (5xx): reintenta solo, hasta 2 veces
      if ((r.status === 429 || r.status >= 500) && intento < 2) {
        var espera = Math.min(parseFloat(r.headers.get("Retry-After")) * 1000 || 1500 * (intento + 1), 4000);
        return new Promise(function (ok) { setTimeout(ok, espera); }).then(function () { return peticionCarrito(ruta, cuerpo, intento + 1); });
      }
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error(j.description || j.message || "carrito");
          err.datos = j;
          throw err;
        }
        return j;
      });
    });
  }

  function agregar(idVariante, cantidad) {
    var cuerpo = { items: [{ id: Number(idVariante), quantity: Number(cantidad) || 1 }] };
    if (document.querySelector("[data-fv-carrito-contenido]")) {
      cuerpo.sections = SECCION_CARRITO;
      cuerpo.sections_url = window.location.pathname;
    }
    return peticionCarrito("cart/add.js", cuerpo);
  }

  function pintarCarrito(html) {
    var actual = document.querySelector("[data-fv-carrito-contenido]");
    if (!html || !actual) return false;
    var tmp = document.createElement("div");
    tmp.innerHTML = html;
    var nuevo = tmp.querySelector("[data-fv-carrito-contenido]");
    if (!nuevo) return false;
    var foco = document.activeElement && actual.contains(document.activeElement) ? document.activeElement : null;
    var focoLinea = foco && foco.getAttribute("data-fv-linea");
    var focoEtiqueta = foco && foco.getAttribute("aria-label");
    actual.innerHTML = nuevo.innerHTML;
    actual.classList.remove("is-cargando");
    var n = nuevo.getAttribute("data-fv-cantidad") || "0";
    actual.setAttribute("data-fv-cantidad", n);
    document.querySelectorAll("[data-fv-cart-count]").forEach(function (b) {
      b.textContent = n;
      b.hidden = n === "0";
    });
    if (foco) {
      var igual = focoLinea && [].slice.call(actual.querySelectorAll('[data-fv-linea="' + focoLinea + '"]')).find(function (b) { return b.getAttribute("aria-label") === focoEtiqueta; });
      var destinoFoco = igual || actual.querySelector(".fv-drawer__cerrar");
      if (destinoFoco) destinoFoco.focus({ preventScroll: true });
    }
    return true;
  }

  function avisoCarrito(texto) {
    var cont = document.querySelector("[data-fv-carrito-contenido]");
    if (!cont) return;
    var p = cont.querySelector(".fv-carrito__error");
    if (!p) {
      p = document.createElement("p");
      p.className = "fv-carrito__error";
      p.setAttribute("role", "alert");
      var cab = cont.querySelector(".fv-drawer__cabecera");
      if (cab && cab.nextSibling) cont.insertBefore(p, cab.nextSibling);
      else cont.appendChild(p);
    }
    p.textContent = texto || cont.getAttribute("data-fv-error") || "";
  }

  function cambiarLinea(linea, cantidad) {
    var cont = document.querySelector("[data-fv-carrito-contenido]");
    if (cont) cont.classList.add("is-cargando");
    peticionCarrito("cart/change.js", {
      line: Number(linea),
      quantity: Math.max(0, Number(cantidad) || 0),
      sections: SECCION_CARRITO,
      sections_url: window.location.pathname
    })
      .then(function (j) {
        if (!pintarCarrito(j.sections && j.sections[SECCION_CARRITO])) window.location.reload();
      })
      .catch(function (err) {
        if (cont) cont.classList.remove("is-cargando");
        avisoCarrito(err && err.datos && err.datos.status === 422 && err.datos.description);
      });
  }

  /* ---------- Eventos globales (una sola vez) ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var el = t.closest("[data-fv-linea]");
    if (el) {
      e.preventDefault();
      cambiarLinea(el.getAttribute("data-fv-linea"), el.getAttribute("data-fv-cant"));
      return;
    }
    el = t.closest("[data-fv-abrir]");
    if (el) {
      if (abrir(el.getAttribute("data-fv-abrir"), el.getAttribute("data-fv-vista"), el)) e.preventDefault();
      return;
    }
    if (t.closest("[data-fv-cerrar]")) {
      e.preventDefault();
      cerrar();
      return;
    }
    el = t.closest("[data-fv-vista-ir]");
    if (el) {
      e.preventDefault();
      if (abierto) { mostrarVista(abierto, el.getAttribute("data-fv-vista-ir")); enfocarVista(); }
      return;
    }
    el = t.closest("a[href*='#']");
    if (!el || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var hash = (el.getAttribute("href") || "").split("#")[1] || "";
    if (PANELES[hash]) {
      e.preventDefault();
      if (abierto && abierto.getAttribute("data-fv-drawer") === "menu") { mostrarVista(abierto, PANELES[hash]); enfocarVista(); }
      else abrir("menu", PANELES[hash], el);
    } else if (hash === "fv-carrito") {
      e.preventDefault();
      abrir("carrito", null, el);
    } else if (hash === "fv-comprar" && document.getElementById("fv-comprar")) {
      e.preventDefault();
      if (abierto) cerrar(true);
      irAComprar();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!abierto) return;
    if (e.key === "Escape") { e.preventDefault(); cerrar(); return; }
    if (e.key !== "Tab") return;
    var panel = abierto.querySelector(".fv-drawer__panel");
    if (!panel) return;
    var focos = [].slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])'))
      .filter(function (x) { return x.offsetParent !== null; });
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (e.shiftKey && (document.activeElement === primero || !panel.contains(document.activeElement))) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && (document.activeElement === ultimo || !panel.contains(document.activeElement))) { e.preventDefault(); primero.focus(); }
  });

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute || !f.hasAttribute("data-fv-rastreo")) return;
    e.preventDefault();
    var campo = f.querySelector("input[name='numero']");
    var numero = campo ? campo.value.replace(/\s+/g, "") : "";
    if (!numero) { if (campo) campo.focus(); return; }
    var base = f.getAttribute("data-url") || "https://t.17track.net/es#nums=";
    window.open(base + encodeURIComponent(numero), "_blank", "noopener");
  });

  // Si la clienta vuelve atrás con el navegador, el carrito se pone al día
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted || !document.querySelector("[data-fv-carrito-contenido]")) return;
    fetch(raiz() + "?sections=" + SECCION_CARRITO)
      .then(function (r) { return r.json(); })
      .then(function (j) { pintarCarrito(j[SECCION_CARRITO]); })
      .catch(function () {});
  });

  /* ---------- Reseñas: filtros, orden, "ver más" y formulario ---------- */
  function initResenas(sec) {
    if (sec.getAttribute("data-fv-listo") === "1") return;
    sec.setAttribute("data-fv-listo", "1");

    var lista = sec.querySelector("[data-fv-resenas-lista]");
    var items = lista ? [].slice.call(lista.children) : [];
    var btnMas = sec.querySelector("[data-fv-resenas-mas]");
    var sinRes = sec.querySelector("[data-fv-resenas-sin]");
    var selOrden = sec.querySelector("[data-fv-resenas-orden]");
    var caja = sec.querySelector("[data-fv-resena-caja]");
    var porPagina = parseInt(sec.getAttribute("data-por-pagina"), 10) || 6;
    // En el editor se ven todas (también los borradores), para poder pulsar cualquiera
    if (window.Shopify && window.Shopify.designMode) porPagina = 1000;
    var filtro = "todas", orden = "recientes", visibles = porPagina;

    items.forEach(function (li, i) {
      var m = (li.getAttribute("data-fecha") || "").match(/(\d{1,2})\D+(\d{1,2})\D+(\d{2,4})/);
      li._fvPos = i;
      li._fvEst = parseInt(li.getAttribute("data-estrellas"), 10) || 0;
      li._fvT = m ? new Date(+(m[3].length === 2 ? "20" + m[3] : m[3]), +m[2] - 1, +m[1]).getTime() : null;
    });

    function pintar() {
      if (!lista) return;
      var l = items.filter(function (li) {
        if (filtro === "todas") return true;
        if (filtro === "foto") return li.getAttribute("data-foto") === "1";
        return li._fvEst === parseInt(filtro, 10);
      });
      l.sort(function (a, b) {
        if (orden === "mejor" && a._fvEst !== b._fvEst) return b._fvEst - a._fvEst;
        if (orden === "peor" && a._fvEst !== b._fvEst) return a._fvEst - b._fvEst;
        if (orden === "recientes" || orden === "antiguas") {
          if (a._fvT !== null && b._fvT !== null && a._fvT !== b._fvT) return orden === "recientes" ? b._fvT - a._fvT : a._fvT - b._fvT;
          if ((a._fvT === null) !== (b._fvT === null)) return a._fvT === null ? 1 : -1;
        }
        return a._fvPos - b._fvPos;
      });
      items.forEach(function (li) { li.hidden = true; });
      l.forEach(function (li, i) { lista.appendChild(li); li.hidden = i >= visibles; });
      if (btnMas) btnMas.hidden = l.length <= visibles;
      if (sinRes) sinRes.hidden = l.length > 0;
      sec.querySelectorAll("[data-fv-filtro]").forEach(function (b) {
        var activo = b.getAttribute("data-fv-filtro") === filtro;
        b.classList.toggle("is-activo", activo);
        if (b.hasAttribute("aria-pressed")) b.setAttribute("aria-pressed", activo ? "true" : "false");
      });
    }

    function abrirForm(enfocar) {
      if (!caja) return;
      caja.hidden = false;
      sec.querySelectorAll("[data-fv-resena-abrir]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      caja.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
      if (enfocar) {
        var campo = caja.querySelector("input[type='text']");
        if (campo) setTimeout(function () { campo.focus({ preventScroll: true }); }, reducido ? 0 : 450);
      }
    }

    sec.addEventListener("click", function (e) {
      var t = e.target;
      var el = t.closest("[data-fv-filtro]");
      if (el) {
        var valor = el.getAttribute("data-fv-filtro");
        filtro = (valor === filtro && valor !== "todas") ? "todas" : valor;
        visibles = porPagina;
        pintar();
        return;
      }
      if (t.closest("[data-fv-resenas-mas]")) { visibles += porPagina; pintar(); return; }
      if (t.closest("[data-fv-resena-abrir]")) { abrirForm(true); return; }
      if (t.closest("[data-fv-resena-cerrar]") && caja) {
        caja.hidden = true;
        sec.querySelectorAll("[data-fv-resena-abrir]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
        var boton = sec.querySelector("[data-fv-resena-abrir]");
        if (boton) boton.focus();
      }
    });
    if (selOrden) selOrden.addEventListener("change", function () { orden = selOrden.value; visibles = porPagina; pintar(); });

    // La reseña y el contacto usan el mismo envío de Shopify; al volver,
    // la dirección lleva #fv-resena-form solo si lo que se envió fue la reseña.
    if (window.location.hash === "#fv-resena-form") abrirForm(false);
    else sec.querySelectorAll("[data-fv-resena-aviso]").forEach(function (a) { a.parentNode.removeChild(a); });

    pintar();
  }

  function abrirAlCargar() {
    if (yaAbiertoAlCargar) return;
    yaAbiertoAlCargar = true;
    var hash = (window.location.hash || "").replace("#", "");
    if (hash === "fv-resena-form") {
      // Se envió una reseña: el aviso del formulario de contacto no corresponde
      document.querySelectorAll("[data-fv-abrir-al-cargar]").forEach(function (el) { el.parentNode.removeChild(el); });
      return;
    }
    var marca = document.querySelector("[data-fv-abrir-al-cargar]");
    if (marca) abrir("menu", marca.getAttribute("data-fv-abrir-al-cargar"));
    else if (PANELES[hash]) abrir("menu", PANELES[hash]);
    else if (hash === "fv-carrito") abrir("carrito");
  }

  /* ---------- Valoración junto al precio (datos de la sección de reseñas) ---------- */
  function initValoracion(el) {
    var resenas = document.getElementById("fv-opiniones");
    var total = resenas ? parseInt(resenas.getAttribute("data-fv-total"), 10) || 0 : 0;
    if (!total) { el.hidden = true; return; }
    var media = resenas.getAttribute("data-fv-media");
    var llenas = parseInt(resenas.getAttribute("data-fv-llenas"), 10) || 0;
    var texto = (el.getAttribute("data-texto") || "").replace("[n]", total);
    el.querySelectorAll("[data-fv-estrella]").forEach(function (s, i) { s.classList.toggle("is-llena", i < llenas); });
    el.querySelector("[data-fv-valoracion-media]").textContent = media;
    el.querySelector("[data-fv-valoracion-cuenta]").textContent = texto;
    el.setAttribute("aria-label", media + " de 5" + (texto ? " · " + texto : "") + ". Ver las reseñas");
    el.hidden = false;
    el.classList.add("is-lista");
    if (el.fvListo) return;
    el.fvListo = true;
    el.addEventListener("click", function (e) {
      var destino = document.getElementById("fv-opiniones");
      if (!destino) return;
      e.preventDefault();
      destino.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
    });
  }

  function init() {
    portal();
    initReveals();
    document.querySelectorAll(".fv-pdp__galeria").forEach(initGaleria);
    document.querySelectorAll("[data-fv-producto]").forEach(initProducto);
    initAcordeones();
    document.querySelectorAll("[data-fv-resenas]").forEach(initResenas);
    document.querySelectorAll("[data-fv-valoracion]").forEach(initValoracion);
    abrirAlCargar();
  }

  // Editor: al elegir el bloque del formulario de reseña, se abre para verlo
  document.addEventListener("shopify:block:select", function (e) {
    var caja = e.target && e.target.closest && e.target.closest("[data-fv-resena-caja]");
    if (caja) { caja.hidden = false; caja.scrollIntoView({ block: "center" }); }
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---------- Editor de temas de Shopify ---------- */
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    document.querySelectorAll('body > [data-fv-portal][data-fv-seccion="' + id + '"]').forEach(function (el) {
      if (abierto === el) cerrar(true);
      el.parentNode.removeChild(el);
    });
  });
  document.addEventListener("shopify:section:select", function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector("[data-fv-carrito-contenido]")) abrir("carrito");
  });
  document.addEventListener("shopify:section:deselect", function () {
    if (abierto) cerrar(true);
  });
  document.addEventListener("shopify:block:select", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-fv-drawer="menu"]')) abrir("menu", t.getAttribute("data-fv-vista") || "menu");
  });
})();
